'use client';

import React from 'react';

interface CalculatorResultsWrapperProps {
  children: React.ReactNode;
}

export const CalculatorResultsWrapper: React.FC<CalculatorResultsWrapperProps> = ({ children }) => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          {children}
        </div>
      </div>
    </section>
  );
};
